module.exports = __webpack_public_path__ + "img/jula-logo.ea7fef62.png";